import {Component, input, model} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {BaseInput} from '../base-input/base-input';

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './select.component.html',
  styleUrl: './select.component.css'
})
export class SelectComponent extends BaseInput {
  options = input.required<Array<{ value: string | number; label: string | number }>>();
  selected = model<string>('');
}
